export default "__VITE_ASSET__Bfawq3vz__"